import { AUTHOR, CONTENT_ITEM, TERM } from 'config/types/entity';

export const active = {
  contentEntities: [],
  error: null,
  loading: {
    siteData: false,
    content: false,
    more: false,
  },
  notFound: false,
  pagination: {
    currentPage: 1,
  },
};

export const archiveRoute = {
  pages: {},
  order: {
    relevance: 'Relevance',
    asc: 'Oldest',
    desc: 'Newest',
  },
  filters: {
    term: {},
    contentItem: {},
  },
};

export const contentGroup = {
  byId: {},
  idBySlug: {},
};

export const user = {
  authentication: {},
  isLoading: false,
};

export default {
  abTester: {
    isLoading: true,
    isInExperimentGroup: false,
    wasQueried: false,
  },
  active,
  archive: {},
  [AUTHOR]: {},
  [CONTENT_ITEM]: {},
  contentType: {},
  menu: {},
  socialMedia: {},
  languages: {},
  languagePicker: {},
  landingPage: null,
  translations: {},
  info: {},
  taxonomy: {},
  [TERM]: {},
  redirect: {},
  footer: {
    text: [],
  },
  user,
  featureFlags: {},
};
